import React, { useState, useEffect, useCallback } from "react";
import { FaChevronCircleUp } from "react-icons/fa";
import PdfPreviewModal from "./PdfPreviewModal";
import reflectionImg from "../../../assets/panda_book.png";
import { progressService } from "../../../services/progressService";

const EbookScreen = ({ onPhaseChange, userId, subsectionId, onProgressUpdate, actions }) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  /* ---------------- Immersive Mode Sync ---------------- */
  useEffect(() => {
    if (isPreviewOpen) {
      // Enter full immersive mode
      onPhaseChange?.("full");
    } else {
      // Restore layout
      onPhaseChange?.("intro");
    }
  }, [isPreviewOpen, onPhaseChange]);

  const markCompleted = useCallback(async () => {
    if (!userId || !subsectionId || isSaving) return;

    setIsSaving(true);
    const safetyTimer = setTimeout(() => {
      setIsSaving(false);
    }, 2000);
    try {
      const updated = await progressService.saveProgress(
        userId,
        subsectionId,
        {
          type: "widget",
          payload: {
            downloaded: true,
          },
        },
        "completed"
      );
      onProgressUpdate?.(updated);
      actions?.setPrimary?.({
        label: "Next Section",
        onClick: () => document.getElementById("next-lesson-btn")?.click(),
        visible: true,
      });
    } catch (error) {
      console.error("Failed to mark ebook as completed:", error);
    } finally {
      clearTimeout(safetyTimer);
      setIsSaving(false);
    }
  }, [userId, subsectionId, isSaving, onProgressUpdate, actions]);

  const handleDownloadClick = () => {
    setIsPreviewOpen(true);
    void markCompleted();
  };

  return (
    <>
      <div className="w-full min-h-[605px] flex flex-col items-center justify-center py-12 px-8 bg-white rounded-[20px]">

        <img
          src={reflectionImg}
          alt="E-book companion"
          className="w-[225px] h-[320px] object-contain mx-auto mb-6"
          loading="lazy"
        />

        <h1 className="text-[28px] leading-[135%] font-medium font-gotham text-[#323232] mb-6 text-center">
          Bonus Resource
          <br />
          Strategic guide to navigating office politics.📚
        </h1>

        <p className="text-base leading-[165%] font-normal text-[#323232] text-center max-w-2xl mb-10 px-4 font-gotham">
          Office politics is happening around you, whether you play it or not.
          <br />
          This ebook shows how to read power, priorities, and people without losing your self-respect.
        </p>

        <button
          onClick={handleDownloadClick}
          disabled={isSaving}
          className="group flex items-center justify-between gap-3 bg-[#54B0AF] hover:bg-teal-600 
                     text-white font-medium rounded-2xl px-6 py-[18px] min-w-[240px]
                     transition-all duration-200 shadow-md hover:shadow-lg focus:outline-none
                     focus:ring-2 focus:ring-[#54B0AF]/50 font-gotham text-base lg:text-lg 2xl:text-[21px]
                     disabled:opacity-70 disabled:cursor-not-allowed"
        >
          <span>{isSaving ? "Saving..." : "Download E-book"}</span>
          <FaChevronCircleUp className="rotate-90 ml-2" />
        </button>
      </div>

      {isPreviewOpen && (
        <PdfPreviewModal
          onClose={() => setIsPreviewOpen(false)}
        />
      )}
    </>
  );
};

export default EbookScreen;
